import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import EnrollmentTable from '@activities/components/tables/enrollment-table/enrollment-table.vue';
import WaitingListTable from '@activities/components/tables/waiting-list-table/waiting-list-table.vue';
import EnrollmentTabs from '@activities/components/tabs/enrollment/enrollment-tabs.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-enrollment',
  components: {
    'bpc-enrollment-table': EnrollmentTable,
    'bpc-enrollment-tabs': EnrollmentTabs,
    'bpc-waiting-list-table': WaitingListTable,
    'bpc-page-title': BpcPageTitle,
  },
})
export default class Enrollments extends Vue {
  public tableToShow = 'enrollments';
  public filterConfigName = 'table';

  mounted() {
    this.onChangeRoute();
  }

  @Watch('$route.name')
  onChangeRoute() {
    switch (this.$route.name) {
      case 'admin-enrollments':
        this.tableToShow = 'enrollments';
        break;
      case 'admin-waiting-list':
        this.tableToShow = 'waiting-list';
        break;
      default:
        break;
    }
  }
}
